import grouper from '@/components/Form/javascripts/grouper';

const GROUPS = {
  MAIN: { title: 'Filtros', subtitle: 'Filtrar resultados da pesquisa' },
};

export default grouper(GROUPS);
